import { IImage } from "@faire/web-api/indigofair/data/IImage";
import * as React from "react";

import { AspectRatioPicture } from "@faire/retailer/components/Image/AspectRatioPicture";
import {
  getDefaultImageUrl,
  getNormalizedImageUrls,
  Transformation,
} from "@faire/retailer/components/Image/ProgressiveProductImage";
import { ImageOverlay } from "@faire/retailer/features/MarketplaceItems/ImageOverlay";
import { VERTICAL_ASPECT_RATIO } from "@faire/retailer/lib/verticalAspectRatio";

const DEFAULT_IMAGE_WIDTH = 720;

export const ProductImageWithSrcsetSizes = ({
  image,
  alt,
  sizes,
  transformation,
  showVerticalImagery,
  dataTestId,
  extraProductsCount,
  smallCount,
  loading,
  onLoad,
  addOverlay = true,
}: {
  image: IImage;
  alt: string;
  sizes: string;
  transformation: Transformation;
  showVerticalImagery?: boolean;
  dataTestId?: string;
  extraProductsCount?: number;
  smallCount?: boolean;
  loading?: HTMLImageElement["loading"];
  onLoad?: () => void;
  addOverlay?: boolean;
}) => {
  const normalizedUrls = getNormalizedImageUrls(image, transformation, {});

  return (
    <>
      <AspectRatioPicture
        $width="100%"
        $ratio={showVerticalImagery ? VERTICAL_ASPECT_RATIO : 1}
        $hideBorder
        data-test-id={dataTestId}
      >
        <source srcSet={normalizedUrls} sizes={sizes} />
        <img
          src={getDefaultImageUrl(
            DEFAULT_IMAGE_WIDTH,
            image,
            transformation,
            {}
          )}
          alt={alt}
          loading={loading}
          data-product-image="full"
          onLoad={onLoad}
        />
        {addOverlay ? (
          <ImageOverlay
            extraProductsCount={extraProductsCount}
            smallCount={smallCount}
          />
        ) : null}
      </AspectRatioPicture>
    </>
  );
};
